import React from 'react';
import CreditCardForm from '../BookingFlow/CreditCardForm';
import ReservationBuilderActions from './actions/ReservationBuilderActions';
import DateHelper from '../DateHelper/DateHelper';
import I18n from 'i18n-js';
import numeral from 'numeral';
// import CurrencyInput from '../CurrencyInput/CurrencyInput';
// import { differenceInDays } from 'date-fns'

export default class ReservationBuilderCustomerCards extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      displayNewCustomerCard: !this.props.reservation.card_id && this.props.reservation.payment_method && this.props.reservation.payment_method.name_on_card && this.props.reservation.payment_method.card_number && this.props.reservation.payment_method.expiration_date && this.props.reservation.payment_method.security_code  ? true : false,
      paymentType: 'card', 
      redemptionCode: '',
      displayVoucherInput: false,
    }
    this.onAddCard = this.onAddCard.bind(this);
    this.onUseThisCard = this.onUseThisCard.bind(this);
    this.onChangeCardInput = this.onChangeCardInput.bind(this);
  };
  
  render() {
    return (
      <fieldset>
        <div className="payment-details row">
          
            <div className="col-md">
            <div className="panel panel-default">
              <div className="panel-heading"><h3 className="panel-title">{I18n.t('payment_details')}</h3></div>
              <div className="panel-body container">
                <div className='row payment-type-wrapper'>

                  <div className='col-md-3 type-select-wrapper'>
                    <label>
                      {I18n.t('payment_method')}
                    </label>
                    <select className="form-control" value={this.props.reservation.payment_method && this.props.reservation.payment_method.payment_type ? this.props.reservation.payment_method.payment_type : 'card'} onChange={this.onChangePaymentType}>
                      <option value="card" >{I18n.t('card')}</option>
                      <option value="cash">{I18n.t('cash')}</option>
                    </select>
                  </div>
                  {this.props.reservation.payment_method && this.props.reservation.payment_method.payment_type && this.props.reservation.payment_method.payment_type == 'cash' ? this.renderCashdrawers() : <div className='col-md cash-drawer-wrapper'></div>}
                </div>
                {(this.props.reservation.payment_method && this.props.reservation.payment_method.payment_type && this.props.reservation.payment_method.payment_type == 'card') || !this.props.reservation.payment_method ? this.renderCustomerCards() : null}
                {this.props.voucher ? null : <p className='redeem-voucher-toggle'><a href="#" onClick={this.toggleRedemtionCode}>{I18n.t(this.state.displayVoucherInput ? 'close_x' : 'redeem_voucher')}</a></p>}
                {this.renderVoucherDetails()}
              </div>
            </div>
            </div>

        </div>

      </fieldset>
    );
  };

  renderCustomerCards() {
    if (this.props.reservation && this.props.reservation.customer) {
      if (this.props.reservation.payment_method && this.props.reservation.payment_method.payment_token) {
        return (
          <div className="PaymentMethod PaymentCards" >
            <p><a href="#" onClick={() => this.onAddCard()} >{I18n.t('remove')}</a></p>
            <label className="saved-card-label">
              <span className={"cc-icon-span credit-card-icon small " + this.props.reservation.payment_method.payment_token.card.brand}></span>
              <span className="cc-details-span">{I18n.t('ending_in').toLowerCase()} <strong>{this.props.reservation.payment_method.payment_token.card.last4}</strong> {I18n.t('exp')} <strong>{this.props.reservation.payment_method.payment_token.card.exp_month}/{this.props.reservation.payment_method.payment_token.card.exp_year}</strong> </span>
            </label>
          </div>
        )
      } else if (!this.state.displayNewCustomerCard && this.props.reservation.customer.cards && this.props.reservation.customer.cards.length ){
        var cards = this.props.reservation.customer.cards.map((card) => {
          return (
            <div className={"card well " + (this.props.reservation.card_id == card.id ? 'card-selected' : '')} key={card.id} >
              <div className="flexed card-input-detail-wrapper">
                <input className="saved-card-input" type="radio" name="card_id" value={card.id} checked={this.props.reservation.card_id == card.id} onChange={() => this.onUseThisCard(card.id)} />
                <label className="saved-card-label">
                  <span className={"cc-icon-span credit-card-icon small " + card.brand}></span>
                  <span className="cc-details-span">{I18n.t('ending_in').toLowerCase()} <strong>{card.last_4}</strong> {I18n.t('exp')} <strong>{card.month}/{card.year}</strong> {I18n.t('last_payment')} <strong>{card.last_payment_date ? DateHelper.printDateToScreen(card.last_payment_date, DateHelper.rubyToDateFNS(this.props.date_format)) : I18n.t('none')}</strong></span>
                </label>
              </div>
            </div>
          );
        });
        return (
          <div className="PaymentMethod  PaymentCards">
            <p><a href="#" onClick={() => !this.state.displayNewCustomerCard ? this.onAddCard() : null}>{I18n.t(!this.state.displayNewCustomerCard ? 'add_new_card' : 'use_existing_cards')}</a></p>
            <div className="cards">{cards}</div>
          </div>
        );
      }  else if (this.state.displayNewCustomerCard || (!this.props.reservation.card_id && this.props.reservation.payment_method && this.props.reservation.customer && this.props.reservation.customer.id && this.props.reservation.customer.cards && this.props.reservation.customer.cards.length)){
        return(
          <div className="PaymentMethod  PaymentCards">
            {<p><a href="#" onClick={() => !this.props.reservation.card_id ? this.useExistingCard() : null}>{I18n.t(!this.props.reservation.card_id ? 'use_existing_cards' : 'add_new_card')}</a></p>}
            <div className="col-md-9 card-form-wrapper">

              <CreditCardForm
                card={this.props.reservation.payment_method}
                saveCard={true}
                customer={this.props.reservation.customer}
                name_on_card={this.props.reservation.customer ? `${this.props.reservation.customer.first_name} ${this.props.reservation.customer.last_name}` : ''}
                onChangeCardInput={this.onChangeCardInput}
                hasClassErrors={this.hasClassErrors}
                renderFieldErrors={this.renderFieldErrors}
                ReservationBuilderCustomerCards={this.props.disableCardNameInput}
                disableNameOnCard={this.props.disableCardNameInput}
                displayCardResetButton={this.props.displayCardResetButton}
                onResetCardElement={this.onResetCardElement}
                incrementCardElementKey={this.props.incrementCardElementKey}
                cardElementKeyIncremented={this.cardElementKeyIncremented}
              />
            </div>
          </div>
        )
      } else if (this.props.reservation.customer.first_name && this.props.reservation.customer.last_name) {
        return (
          <div className="PaymentMethod  PaymentCards">
            <div className="col-md-9 card-form-wrapper">
              <CreditCardForm
                card={this.props.reservation.payment_method ? this.props.reservation.payment_method : { save_card: true, payment_type: 'card', cash_drawer: '' }}
                saveCard={true}
                name_on_card={this.props.reservation.customer ? `${this.props.reservation.customer.first_name} ${this.props.reservation.customer.last_name}` : ''}
                customer={this.props.reservation.customer}
                onChangeCardInput={this.onChangeCardInput}
                ReservationBuilder={true}
                hasClassErrors={this.hasClassErrors}
                renderFieldErrors={this.renderFieldErrors}
                ReservationBuilderCustomerCards={this.props.disableCardNameInput}
                disableNameOnCard={this.props.disableCardNameInput}
                displayCardResetButton={this.props.displayCardResetButton}
                onResetCardElement={this.onResetCardElement}
                incrementCardElementKey={this.props.incrementCardElementKey}
                cardElementKeyIncremented={this.cardElementKeyIncremented}
              />
            </div>
          </div>
        );
      } else {
        return (
          <div className="jumbotron" style={{ marginBottom: 0 }}>
            <p className="text-center" style={{ marginBottom: 0 }}>{I18n.t('select_customer_to_set_cards')}</p>
          </div>
        );
      };
    } else {
      return (
        <div className="jumbotron" style={{ marginBottom: 0 }}>
          <p className="text-center" style={{ marginBottom: 0 }}>{I18n.t('select_customer_to_set_cards')}</p>
        </div>
      );
    };
  };

  renderCashdrawers = () => {
    var drawers = this.props.cash_drawers.map((drawer) => <option key={drawer.id} value={drawer.id}>{drawer.name}</option>)
    
    return(
      <div className='col-md-3 cash-drawer-wrapper'>
        <label>
          {I18n.t('cash_drawer')}
        </label>
        <select className="form-control" value={this.props.reservation && this.props.reservation.payment_method && this.props.reservation.payment_method.cash_drawer ? this.props.reservation.payment_method.cash_drawer : ''} onChange={this.onChangeChashDrawer}>
          <option value='' disabled></option>
          {drawers}
        </select>
      </div>
    );
  };

  renderVoucherDetails = () => {
    if(this.state.displayVoucherInput && !this.props.voucher) {
      return (
        <div className="row">
          <div className="form-group col-md-3">
            <label>{I18n.t('redemption_code')}</label>
            <input className={this.hasClassErrors('redemption_code') ? "form-control has-errors" : "form-control"} name="redemption_code" value={this.state.redemptionCode} onChange={this.onChangeVoucherCode} />
            {this.renderFieldErrors('redemption_code')}
            <button className="btn  btn-primary enter-voucher-code" onClick={this.getVoucher} >{I18n.t('enter')}</button>
          </div>
        </div>
      );
    } else if (this.props.voucher && this.props.voucher.redemption_code && this.props.voucher.balance){
      return(
        <div className="row redeemed-voucher-wrapper">
          <div className="form-group col-md-2">
            <label>{I18n.t('redemption_code')}</label>
            <div>{this.props.voucher.redemption_code}</div>
          </div>
          <div className="form-group col-md-1">
            <label>{I18n.t('balance')}</label>
            <div>{this.formatCurrency(this.props.voucher.balance)}</div>
          </div>
          <div className="form-group col-md-2">
            <button className="btn  btn-primary enter-voucher-code" onClick={this.removeVoucher} >{I18n.t('remove')}</button>
          </div>
        </div>
      );
    };

  };

  toggleRedemtionCode = () => {
    this.setState({ displayVoucherInput: !this.state.displayVoucherInput })
  }

  onChangeVoucherCode = (e) => {
    this.setState({redemptionCode: e.target.value});
  };

  onAddCard() {
    this.setState({
      displayNewCustomerCard: true,
    }, ReservationBuilderActions.addCard({ save_card: true, payment_type: 'card' }));
  };

  onUseThisCard(id) {
    ReservationBuilderActions.setValue('reservation.card_id', id);
  };

  useExistingCard(){
    this.setState({
      displayNewCustomerCard: false,
    });
  };

  renderFieldErrors = (braketReference) => {
    if (this.props.card_errors && this.props.card_errors.field_errors && this.props.card_errors.field_errors[braketReference]) {
      return <div className="help-block"><ul><li><b>&#x2022;</b>{this.props.card_errors.field_errors[braketReference]}</li></ul></div>
    } else {
      return null;
    }
  };

  hasClassErrors = (braketReference) => {
    if (this.props.card_errors && this.props.card_errors.field_errors && this.props.card_errors.field_errors[braketReference]) {
      return true;
    } else {
      return false;
    };
  };

  onChangeCardInput(e) {
    var card = this.props.reservation.payment_method ? Object.assign({}, this.props.reservation.payment_method) : { save_card: true }

    if (e.target.name === 'save_card') {
      card[e.target.name] = e.target.checked;
    } else {
      card[e.target.name] = e.target.value;
    };
    ReservationBuilderActions.changeCardInput(card);
  };

  onResetCardElement = () => {
    ReservationBuilderActions.resetCardDetails();
  };

  onChangePaymentType = (e) => {
    ReservationBuilderActions.changeCardInput({ payment_type: e.target.value, cash_drawer: '', save_card: e.target.value == 'card' ? true : false});
  };

  onChangeChashDrawer = (e) => {
    ReservationBuilderActions.changeCardInput({ payment_type: 'cash', cash_drawer: e.target.value});
  };

  getVoucher = () => {
    $.ajax({
      type: 'POST',
      url: this.props.redeem_voucher_path,
      data: {
        voucher: {
          redemption_code: this.state.redemptionCode,
        },
      },
    }).done((response) => {
      if (response.id) {
        ReservationBuilderActions.voucherAdded(response);
      } else if (response.errors) {
        if (response.errors.redemption_code) {
          var paymentErrors = {
          header_errors: [I18n.t('redemption_code_cannot_be_found')]
          };

          ReservationBuilderActions.setCardErrorsToState(paymentErrors)
        } else if (response.errors.expiration_date) {
          var paymentErrors = {
            header_errors: [I18n.t('voucher_has_expired')]
          };

          ReservationBuilderActions.setCardErrorsToState(paymentErrors)
        } else if (response.errors.void) {
          var paymentErrors = {
            header_errors: [I18n.t('voucher_is_void')]
          };

          ReservationBuilderActions.setCardErrorsToState(paymentErrors)
        } else if (response.errors.balance) {
          var paymentErrors = {
            header_errors: [I18n.t('balance_is_zero')]
          };

          ReservationBuilderActions.setCardErrorsToState(paymentErrors)
        };
      };
    });
  };

  removeVoucher = async () => {
    ReservationBuilderActions.voucherAdded(null);
    this.setState({displayVoucherInput: false, redemptionCode: ''});
  };

  formatCurrency = (num) => {
    return I18n.t('number.currency.format.unit') + numeral(num / 100).format('0' + I18n.t('number.currency.format.delimiter') + '0.00');
  };

  cardElementKeyIncremented = () => {
    ReservationBuilderActions.cardElementKeyIncremented();
  };
}
